import {
  Companion_instance25ullnynvxd0w as Companion_instance,
  _Result___init__impl__xyqfz83a5421h46yeyh as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result3t1vadv16kmzk as Result,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  newThrowablezl37abp36p5f as newThrowable,
  protoOf180f3jzyo7rfj as protoOf,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString1h6jjoch8cjt8 as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { stackTraceToString2670q6lbhdojj as stackTraceToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { get_DEVELOPMENT_MODE18ax9b1n971lk as get_DEVELOPMENT_MODE } from './ByteChannel.web.mjs';
import { rethrowCloseCauseIfNeededeln8lm5agg4u as rethrowCloseCauseIfNeeded } from './ByteReadChannelOperations.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  numberToLong2pakxeg38estk as numberToLong,
  add2suhfggl4zvkk as add,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  intercepted2ogpsikxxj4u0 as intercepted,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { returnIfSuspended1blqheeew1z6h as returnIfSuspended } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  get_CLOSED3uiwvc5y98ftj as get_CLOSED,
  CloseToken4utf44psnuyc as CloseToken,
} from './CloseToken.mjs';
import {
  ClosedReadChannelException9jdpzh6uy12w as ClosedReadChannelException,
  ClosedWriteChannelException1eeenxj0c4bxu as ClosedWriteChannelException,
} from './Exceptions.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from '../../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import {
  awaitContent$default12h4qgz8umrzx as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { ByteWriteChannel3jkhlhzuuoxp1 as ByteWriteChannel } from './ByteWriteChannel.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.x4h_1 = new (Closed())(null);
        var tmp = this;
        // Inline function 'kotlin.Companion.success' call
        tmp.y4h_1 = _Result___init__impl__xyqfz8(Unit_instance);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var EmptyClass;
function Empty() {
  if (EmptyClass === VOID) {
    class $ {
      toString() {
        return 'Empty';
      }
      hashCode() {
        return -231472095;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Empty()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Empty');
    EmptyClass = $;
  }
  return EmptyClass;
}
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
var ClosedClass;
function Closed() {
  if (ClosedClass === VOID) {
    class $ {
      constructor(cause) {
        this.z4h_1 = cause;
      }
      toString() {
        return 'Closed(cause=' + toString(this.z4h_1) + ')';
      }
      hashCode() {
        return this.z4h_1 == null ? 0 : hashCode(this.z4h_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Closed()))
          return false;
        if (!equals(this.z4h_1, other.z4h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Closed');
    ClosedClass = $;
  }
  return ClosedClass;
}
function resume() {
  return this.b4i().tc(Companion_getInstance().y4h_1);
}
function resume_0(throwable) {
  var tmp = this.b4i();
  var tmp_0;
  if (throwable == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(throwable));
    tmp_0 = new (Result())(tmp$ret$2);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp.tc(tmp1_elvis_lhs == null ? Companion_getInstance().y4h_1 : tmp1_elvis_lhs.ht_1);
}
var TaskClass;
function Task() {
  if (TaskClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Task');
    TaskClass = $;
  }
  return TaskClass;
}
var ReadClass;
function Read() {
  if (ReadClass === VOID) {
    class $ {
      constructor(continuation) {
        this.f4i_1 = continuation;
        this.g4i_1 = null;
        if (get_DEVELOPMENT_MODE()) {
          var tmp = this;
          // Inline function 'kotlin.also' call
          var this_0 = newThrowable('ReadTask 0x' + toString_0(hashCode(this.f4i_1), 16));
          stackTraceToString(this_0);
          tmp.g4i_1 = this_0;
        }
      }
      b4i() {
        return this.f4i_1;
      }
      a4i() {
        return this.g4i_1;
      }
      c4i() {
        return 'read';
      }
    }
    protoOf($).d4i = resume;
    protoOf($).e4i = resume_0;
    initMetadataForClass($, 'Read', VOID, VOID, [Task()]);
    ReadClass = $;
  }
  return ReadClass;
}
var WriteClass;
function Write() {
  if (WriteClass === VOID) {
    class $ {
      constructor(continuation) {
        this.h4i_1 = continuation;
        this.i4i_1 = null;
        if (get_DEVELOPMENT_MODE()) {
          var tmp = this;
          // Inline function 'kotlin.also' call
          var this_0 = newThrowable('WriteTask 0x' + toString_0(hashCode(this.h4i_1), 16));
          stackTraceToString(this_0);
          tmp.i4i_1 = this_0;
        }
      }
      b4i() {
        return this.h4i_1;
      }
      a4i() {
        return this.i4i_1;
      }
      c4i() {
        return 'write';
      }
    }
    protoOf($).d4i = resume;
    protoOf($).e4i = resume_0;
    initMetadataForClass($, 'Write', VOID, VOID, [Task()]);
    WriteClass = $;
  }
  return WriteClass;
}
function *_generator_awaitContent__vf28kb($this, min, $completion) {
  rethrowCloseCauseIfNeeded($this);
  if ($this.o4i_1.v2() >= fromInt(min))
    return true;
  // Inline function 'io.ktor.utils.io.ByteChannel.sleepWhile' call
  $l$loop: while (add(numberToLong($this.l4i_1), $this.o4i_1.v2()) < fromInt(min) && $this.q4i_1.kotlinx$atomicfu$value == null) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
    cancellable.c11();
    var tmp2 = new (Read())(cancellable);
    $l$block_0: {
      // Inline function 'io.ktor.utils.io.ByteChannel.trySuspend' call
      var previous = $this.n4i_1.kotlinx$atomicfu$value;
      if (!(previous instanceof Closed())) {
        if (!$this.n4i_1.atomicfu$compareAndSet(previous, tmp2)) {
          tmp2.d4i();
          break $l$block_0;
        }
      }
      if (previous instanceof Read()) {
        previous.e4i(ConcurrentIOException().v4i(tmp2.c4i(), previous.a4i()));
      } else {
        if (isInterface(previous, Task())) {
          previous.d4i();
        } else {
          if (previous instanceof Closed()) {
            tmp2.e4i(previous.z4h_1);
            break $l$block_0;
          } else {
            if (!equals(previous, Empty_instance)) {
              noWhenBranchMatchedException();
            }
          }
        }
      }
      if (!(add(numberToLong($this.l4i_1), $this.o4i_1.v2()) < fromInt(min) && $this.q4i_1.kotlinx$atomicfu$value == null)) {
        // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
        var current = $this.n4i_1.kotlinx$atomicfu$value;
        var tmp;
        if (current instanceof Read()) {
          tmp = $this.n4i_1.atomicfu$compareAndSet(current, Empty_instance);
        } else {
          tmp = false;
        }
        if (tmp) {
          current.d4i();
        }
      }
    }
    var tmp$ret$6 = cancellable.my();
    var tmp_0 = returnIfSuspended(tmp$ret$6, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  if ($this.o4i_1.v2() < 1048576n) {
    moveFlushToReadBuffer($this);
  }
  return $this.o4i_1.v2() >= fromInt(min);
}
function moveFlushToReadBuffer($this) {
  // Inline function 'io.ktor.utils.io.locks.synchronized' call
  $this.m4i_1;
  $this.k4i_1.x4f($this.o4i_1);
  $this.l4i_1 = 0;
  // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
  var current = $this.n4i_1.kotlinx$atomicfu$value;
  var tmp;
  if (current instanceof Write()) {
    tmp = $this.n4i_1.atomicfu$compareAndSet(current, Empty_instance);
  } else {
    tmp = false;
  }
  if (tmp) {
    current.d4i();
  }
}
function *_generator_flush__owbk1c($this, $completion) {
  rethrowCloseCauseIfNeeded($this);
  $this.w4i();
  if ($this.l4i_1 < 1048576)
    return Unit_instance;
  // Inline function 'io.ktor.utils.io.ByteChannel.sleepWhile' call
  $l$loop: while ($this.l4i_1 >= 1048576 && $this.q4i_1.kotlinx$atomicfu$value == null) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
    cancellable.c11();
    var tmp2 = new (Write())(cancellable);
    $l$block_0: {
      // Inline function 'io.ktor.utils.io.ByteChannel.trySuspend' call
      var previous = $this.n4i_1.kotlinx$atomicfu$value;
      if (!(previous instanceof Closed())) {
        if (!$this.n4i_1.atomicfu$compareAndSet(previous, tmp2)) {
          tmp2.d4i();
          break $l$block_0;
        }
      }
      if (previous instanceof Write()) {
        previous.e4i(ConcurrentIOException().v4i(tmp2.c4i(), previous.a4i()));
      } else {
        if (isInterface(previous, Task())) {
          previous.d4i();
        } else {
          if (previous instanceof Closed()) {
            tmp2.e4i(previous.z4h_1);
            break $l$block_0;
          } else {
            if (!equals(previous, Empty_instance)) {
              noWhenBranchMatchedException();
            }
          }
        }
      }
      if (!($this.l4i_1 >= 1048576 && $this.q4i_1.kotlinx$atomicfu$value == null)) {
        // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
        var current = $this.n4i_1.kotlinx$atomicfu$value;
        var tmp;
        if (current instanceof Write()) {
          tmp = $this.n4i_1.atomicfu$compareAndSet(current, Empty_instance);
        } else {
          tmp = false;
        }
        if (tmp) {
          current.d4i();
        }
      }
    }
    var tmp$ret$6 = cancellable.my();
    var tmp_0 = returnIfSuspended(tmp$ret$6, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function *_generator_flushAndClose__wsi7db($this, $completion) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    var tmp_0 = $this.x4i($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    // Inline function 'kotlin.Companion.success' call
    tmp = _Result___init__impl__xyqfz8(Unit_instance);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  if (!$this.q4i_1.atomicfu$compareAndSet(null, get_CLOSED()))
    return Unit_instance;
  closeSlot($this, null);
  return Unit_instance;
}
function closeSlot($this, cause) {
  var closeContinuation = !(cause == null) ? new (Closed())(cause) : Companion_getInstance().x4h_1;
  var continuation = $this.n4i_1.atomicfu$getAndSet(closeContinuation);
  if (isInterface(continuation, Task())) {
    continuation.e4i(cause);
  }
}
function ClosedReadChannelException$_init_$ref_ix0089() {
  var l = (p0) => ClosedReadChannelException().c4j(p0);
  l.callableName = '<init>';
  return l;
}
function ClosedWriteChannelException$_init_$ref_ef15ty() {
  var l = (p0) => ClosedWriteChannelException().h4j(p0);
  l.callableName = '<init>';
  return l;
}
var ByteChannelClass;
function ByteChannel() {
  if (ByteChannelClass === VOID) {
    class $ {
      constructor(autoFlush) {
        autoFlush = autoFlush === VOID ? false : autoFlush;
        this.j4i_1 = autoFlush;
        this.k4i_1 = new (Buffer())();
        this.l4i_1 = 0;
        this.m4i_1 = new Object();
        this.n4i_1 = atomic$ref$1(Empty_instance);
        this.o4i_1 = new (Buffer())();
        this.p4i_1 = new (Buffer())();
        this.q4i_1 = atomic$ref$1(null);
      }
      i4j() {
        return this.j4i_1;
      }
      j4j() {
        var tmp0_safe_receiver = this.q4i_1.kotlinx$atomicfu$value;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.l4j(ClosedReadChannelException$_init_$ref_ix0089());
        }
        if (this.o4i_1.b3y()) {
          moveFlushToReadBuffer(this);
        }
        return this.o4i_1;
      }
      m4j() {
        if (this.n4j()) {
          var tmp0_safe_receiver = this.q4i_1.kotlinx$atomicfu$value;
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            tmp = tmp0_safe_receiver.l4j(ClosedWriteChannelException$_init_$ref_ef15ty());
          }
          if (tmp == null)
            throw ClosedWriteChannelException().h4j();
        }
        return this.p4i_1;
      }
      o4j() {
        var tmp0_safe_receiver = this.q4i_1.kotlinx$atomicfu$value;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p4j();
      }
      n4j() {
        return !(this.q4i_1.kotlinx$atomicfu$value == null);
      }
      q4j() {
        return !(this.o4j() == null) || (this.n4j() && this.l4i_1 === 0 && this.o4i_1.b3y());
      }
      r4j(min, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_awaitContent__vf28kb.bind(VOID, this, min), $completion);
      }
      x4i($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_flush__owbk1c.bind(VOID, this), $completion);
      }
      w4i() {
        if (this.p4i_1.b3y())
          return Unit_instance;
        // Inline function 'io.ktor.utils.io.locks.synchronized' call
        this.m4i_1;
        var count = convertToInt(this.p4i_1.v2());
        this.k4i_1.j4g(this.p4i_1);
        this.l4i_1 = this.l4i_1 + count | 0;
        // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
        var current = this.n4i_1.kotlinx$atomicfu$value;
        var tmp;
        if (current instanceof Read()) {
          tmp = this.n4i_1.atomicfu$compareAndSet(current, Empty_instance);
        } else {
          tmp = false;
        }
        if (tmp) {
          current.d4i();
        }
      }
      q6() {
        this.w4i();
        if (!this.q4i_1.atomicfu$compareAndSet(null, get_CLOSED()))
          return Unit_instance;
        closeSlot(this, null);
      }
      t4j($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_flushAndClose__wsi7db.bind(VOID, this), $completion);
      }
      u4j(cause) {
        if (!(this.q4i_1.kotlinx$atomicfu$value == null))
          return Unit_instance;
        var closedToken = new (CloseToken())(cause);
        this.q4i_1.atomicfu$compareAndSet(null, closedToken);
        var wrappedCause = closedToken.p4j();
        closeSlot(this, wrappedCause);
      }
      toString() {
        return 'ByteChannel[' + hashCode(this) + ']';
      }
    }
    protoOf($).s4j = awaitContent$default;
    initMetadataForClass($, 'ByteChannel', ByteChannel, VOID, [ByteReadChannel(), ByteWriteChannel()], [1, 0]);
    ByteChannelClass = $;
  }
  return ByteChannelClass;
}
var ConcurrentIOExceptionClass;
function ConcurrentIOException() {
  if (ConcurrentIOExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static v4i(taskName, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.q('Concurrent ' + taskName + ' attempts', cause);
        captureStack($this, $this.u4i_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ConcurrentIOException');
    ConcurrentIOExceptionClass = $;
  }
  return ConcurrentIOExceptionClass;
}
//region block: init
Empty_instance = new (Empty())();
//endregion
//region block: exports
export {
  ByteChannel as ByteChannel3cxdguezl3lu7,
};
//endregion

//# sourceMappingURL=ByteChannel.mjs.map
